"use strict";

exports.__esModule = true;
exports.TicketTypesToolbar = TicketTypesToolbar;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _System = require("../../../System");
var _Core = require("../../Core");
var _TicketTypeListContext = require("../TicketTypeListContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function TicketTypesToolbar(props) {
  var _props$showCreateButt = props.showCreateButton,
    showCreateButton = _props$showCreateButt === void 0 ? true : _props$showCreateButt;
  var ticketTypes = _react["default"].useContext(_TicketTypeListContext.TicketTypeListContext);
  var count = ticketTypes.getFiltered().length;
  var onFilterChange = ticketTypes.onFilterChange,
    filterValue = ticketTypes.filterValue,
    enabledFilterOn = ticketTypes.enabledFilterOn,
    onChangeEnabled = ticketTypes.onChangeEnabled;
  return /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, null, /*#__PURE__*/_react["default"].createElement(_Core.SearchInput, {
    onChange: onFilterChange,
    value: filterValue
  }), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
    minimal: true,
    style: {
      marginLeft: "1rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    type: "button",
    active: enabledFilterOn,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "enabled",
      defaultMessage: "Enabled"
    }),
    onClick: function onClick() {
      return onChangeEnabled(true);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    type: "button",
    active: !enabledFilterOn,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "disabled",
      defaultMessage: "Disabled"
    }),
    onClick: function onClick() {
      return onChangeEnabled(false);
    }
  })), /*#__PURE__*/_react["default"].createElement(_Core.ToolbarDescription, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "TicketTypesToolbar.count",
    defaultMessage: "\n              {value} {count, plural,\n                one {ticket type}\n                other {ticket types}\n              }\n            ",
    values: {
      value: /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
        value: count
      })),
      count: count
    }
  }))), showCreateButton && /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
    style: {
      marginLeft: "auto"
    },
    intent: _core.Intent.PRIMARY,
    icon: _icons.IconNames.ADD,
    to: (0, _System.getScreenURL)("CreateTicketType")
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "TicketTypeToolbar.createTicketTypeButton.text",
    defaultMessage: "Create Ticket Type"
  })));
}